import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import Save from "./save";
import Edit from "./Edit";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        id="a"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="m18,2.2H6c-2.1,0-3.8,1.7-3.8,3.8v12c0,2.1,1.7,3.8,3.8,3.8h12c2.1,0,3.8-1.7,3.8-3.8V6c0-2.1-1.7-3.8-3.8-3.8Zm2.2,15.8c0,1.2-1,2.2-2.2,2.2H6c-1.2,0-2.2-1-2.2-2.2V6c0-1.2,1-2.2,2.2-2.2h12c1.2,0,2.2,1,2.2,2.2v12Z"
          stroke-width="0"
        />
        <path
          d="m13.8,9.1c.4,0,.8-.3.8-.8s-.3-.8-.8-.8c-.7,0-1.3.3-1.8.7-.5-.5-1.1-.7-1.8-.7-.4.1-.7.5-.7.9s.3.8.8.8c.6,0,1,.5,1,1v3.6c0,.6-.5,1-1,1-.4,0-.8.3-.8.8s.3.8.8.8c.7,0,1.3-.3,1.8-.7.5.5,1.1.7,1.8.7.4,0,.8-.3.8-.8s-.3-.8-.8-.8c-.6,0-1-.5-1-1v-3.6c-.1-.6.3-1.1.9-1.1Z"
          stroke-width="0"
        />
      </svg>
    ),
  },
});
